import Markdown from './Markdown'
import ReferenceChips from '../references/ReferenceChips'
import MessageExport from './MessageExport'
import { GuideChips } from '../guides/GuideChips'
import { standardName } from '../../utils/standardRef'
import { useModal } from '../../context/ModalContext'
import './MessageBubble.css'

const ICON_PROPS = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
}

const IconNote = () => (
  <svg {...ICON_PROPS}>
    <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
    <polyline points="14 3 14 9 20 9" />
    <line x1="12" y1="12" x2="12" y2="18" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
)

const IconSend = () => (
  <svg {...ICON_PROPS}>
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
)

// One chat turn rendered as a full-width colored band (user vs assistant get
// different tints). `highlighted` briefly flashes the band when the message is
// jumped to from search. Assistant turns show a References strip of the items
// the answer cited; `onOpenItem(item)` opens one in the viewer. When `exportScope`
// + `chatId` are supplied, saved assistant answers get Download, Add to note, and
// Send to chat actions.
function MessageBubble({ message, highlighted, onOpenItem, exportScope, chatId }) {
  const { openModal } = useModal()
  const isUser = message.role === 'user'
  const source = { scope: exportScope, chatId, messageId: message._id }
  const canExport =
    !isUser &&
    !message.pending &&
    exportScope &&
    chatId &&
    message._id &&
    !String(message._id).startsWith('tmp-')

  return (
    <div
      className={`msg-band ${isUser ? 'msg-band-user' : 'msg-band-assistant'} ${
        message.pending ? 'msg-pending' : ''
      } ${highlighted ? 'msg-band-highlight' : ''}`}
    >
      <div className="msg-band-inner">
        <div className="msg-role">
          {isUser ? 'You' : 'Codetalk'}
          {!isUser && message.model && <span className="msg-model">{message.model}</span>}
        </div>
        {isUser ? (
          <div className="msg-text">{message.text}</div>
        ) : (
          <Markdown>{message.text}</Markdown>
        )}
        <GuideChips guides={message.guides} />
        {!isUser && (
          <ReferenceChips
            items={message.items}
            onOpenItem={onOpenItem}
            groupBy={(item) => standardName(item.standard) || 'Standard'}
          />
        )}
        {canExport && (
          <div className="msg-actions">
            <MessageExport scope={exportScope} chatId={chatId} messageId={message._id} />
            <button
              type="button"
              className="msg-export-btn"
              title="Add this answer to a note"
              onClick={() => openModal('answer-to-note', { source })}
            >
              <IconNote />
              <span>Add to note</span>
            </button>
            <button
              type="button"
              className="msg-export-btn"
              title="Send this answer to a chat"
              onClick={() => openModal('answer-to-chat', { source })}
            >
              <IconSend />
              <span>Send to chat</span>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default MessageBubble
